var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraftLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 2.41667H21.75V0H19.3333V2.41667H9.66667V0H7.25V2.41667H3.625C1.62642 2.41667 0 4.04308 0 6.04167V29H29V6.04167C29 4.04308 27.3736 2.41667 25.375 2.41667ZM3.625 4.83333H25.375C26.042 4.83333 26.5833 5.37587 26.5833 6.04167V9.66667H2.41667V6.04167C2.41667 5.37587 2.958 4.83333 3.625 4.83333ZM2.41667 26.5833V12.0833H26.5833V26.5833H2.41667ZM6.04167 15.7083H22.9583V18.125H6.04167V15.7083ZM6.04167 20.5417H14.5V22.9583H6.04167V20.5417Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftLogo);
export default __webpack_public_path__ + "static/media/draft-logo.445ebcb580ef223bb290073cd13ebae8.svg";
export { ForwardRef as ReactComponent };